import React from "react";
import styled from "styled-components";
import { TextEditorCharacterCount } from "./TextEditorCharacterCount";
import { FlexBox } from "../../FlexContainer";
import { InlineStyles } from "./InlineStyles";
import { BlockTypes } from "./BlockTypes";
import { SpecialTools } from "./SpecialTools";
export const TextEditorToolbar = ({
  click,
  inlineStyles,
  inlineStyleActive,
  inlineOnMouseDown,
  editorState,
  blockTypes,
  blockIsActive,
  blockOnMouseDown,
  specialTools,
  characterCountLimit,
  counterPlugin,
  countFunction,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", {
    onClick: click
  }, /*#__PURE__*/React.createElement(TextEditorToolbarContainer, null, /*#__PURE__*/React.createElement(FlexBox, null, /*#__PURE__*/React.createElement(InlineStyles, {
    styles: inlineStyles,
    isActive: inlineStyleActive,
    onMouseDown: inlineOnMouseDown,
    editorState: editorState
  }), /*#__PURE__*/React.createElement(BlockTypes, {
    types: blockTypes,
    isActive: blockIsActive,
    onMouseDown: blockOnMouseDown,
    editorState: editorState
  }), /*#__PURE__*/React.createElement(SpecialTools, {
    tools: specialTools,
    editorState: editorState
  })), characterCountLimit && /*#__PURE__*/React.createElement(TextEditorCharacterCount, {
    characterCountLimit: characterCountLimit,
    editorState: editorState,
    counterPlugin: counterPlugin,
    countFunction: countFunction
  })));
};
export const TextEditorToolbarContainer = styled.div`
  display: flex;
  border: ${props => props.theme.borders.input};
  border-top: none;
  border-radius: 0 0 4px 4px;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.colors.toolbarBackground};
  padding: 3px;
`;